import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { ArcMark } from '../ui/ArcMark';

const Login: React.FC = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const { login, error, loading, clearError } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const handleNavigateToRegister = () => {
    clearError();
    navigate('/register');
  };

  const handleNavigateToForgotPassword = () => {
    clearError();
    navigate('/forgot-password');
  };

  const from = (location.state as any)?.from?.pathname || '/dashboard';

  const handleEmailLogin = async (e: React.FormEvent) => {
    e.preventDefault();

    try {
      await login(email, password);
      navigate(from, { replace: true });
    } catch (err: any) {
      // Error is already set in AuthContext
    }
  };

  return (
    <div className="pk-auth">
      <div className="pk-auth-pane">
        <div className="pk-auth-card">
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <ArcMark variant="current" size={24} style={{ color: 'var(--arc-accent)' }} />
            <span style={{ fontFamily: 'var(--arc-font-display)', fontWeight: 800, fontSize: 18, color: 'var(--arc-ink)' }}>ARC Portal</span>
          </div>

          <div>
            <h1 className="pk-h2">Sign in</h1>
            <p className="pk-sub" style={{ marginTop: 4 }}>Welcome back — manage your API keys, models, and usage.</p>
          </div>

          {error && <div className="pk-note pk-note-danger">{error}</div>}

          <form onSubmit={handleEmailLogin} style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
            <div className="pk-field">
              <label className="pk-field-label" htmlFor="email">Email Address</label>
              <input
                id="email"
                name="email"
                type="email"
                autoComplete="email"
                autoFocus
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                disabled={loading}
                className="pk-input"
              />
            </div>

            <div className="pk-field">
              <label className="pk-field-label" htmlFor="password">Password</label>
              <input
                id="password"
                name="password"
                type="password"
                autoComplete="current-password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                disabled={loading}
                className="pk-input"
              />
            </div>

            <div style={{ textAlign: 'center' }}>
              <button type="button" onClick={handleNavigateToForgotPassword} className="pk-btn-text">
                Forgot password?
              </button>
            </div>

            <button
              type="submit"
              disabled={!email || !password || loading}
              className="pk-btn pk-btn-grad pk-btn-lg pk-btn-block"
            >
              {loading ? <span className="pk-spinner" style={{ borderTopColor: '#fff' }} /> : 'Sign In'}
            </button>
          </form>

          <hr className="pk-rule" />

          <div style={{ textAlign: 'center', display: 'flex', flexDirection: 'column', gap: 10 }}>
            <p className="pk-sub">Don't have an account?</p>
            <button type="button" onClick={handleNavigateToRegister} className="pk-btn pk-btn-outline pk-btn-block">
              Sign Up
            </button>
          </div>
        </div>
      </div>

      <div className="pk-auth-side">
        <span className="pk-label">ARC · Developer Portal</span>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
          <h3 style={{ fontFamily: 'var(--arc-font-display)', fontWeight: 800, fontSize: 30, letterSpacing: '-.035em', lineHeight: 1.1, margin: 0, color: '#F7F5F3', maxWidth: '22ch' }}>
            One key, every model.
          </h3>
          <p style={{ margin: 0, fontSize: 14, lineHeight: 1.65, color: 'rgba(247,245,243,.66)', maxWidth: '44ch' }}>
            Manage access, usage, and routing rules in one place — task determination and per-call accounting behind a single endpoint.
          </p>
        </div>
        <div style={{ display: 'flex', gap: 20, flexWrap: 'wrap' }}>
          <span className="pk-mono" style={{ fontSize: 11, letterSpacing: '.16em', textTransform: 'uppercase', color: 'rgba(247,245,243,.5)' }}>api.askarc.app</span>
          <span className="pk-mono" style={{ fontSize: 11, letterSpacing: '.16em', textTransform: 'uppercase', color: 'rgba(247,245,243,.5)' }}>docs</span>
        </div>
      </div>
    </div>
  );
};

export default Login;
